// import React from 'react';
// import Footer from "../../Components/Footer";
// import Header from "../../Components/Header";
// import jobOpenings from '../../Data/jobOpenings.json';
// import FadeInSection from "../../Components/FadeInSection.jsx";
// import SearchBar from "../Verification/SearchBar.jsx";
// import Banner from "../../Components/Banner";

// const Careers = () => {
//     return (
//         <div>
//                 <Header />
//             <div className="font-ubuntu bg-topo-bg careers ">
//                 <div className="careers-header text-center mb-8">
//                     {/* <h1 className="text-4xl font-bold">Careers</h1>
//                     <p className="text-lg mt-2">Join us in our mission to make the roads safer for everyone.</p> */}
//                     <Banner 
//       imageUrl="./banner1.svg"
//       title="Careers"
//       subtitle="Join us in our mission to make the roads safer for everyone."
//        />
//                 </div>
//                 <SearchBar />
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
//                     {jobOpenings.map((job) => (
//                         <div key={job.id} className="p-6 border rounded-lg shadow-lg bg-white flex flex-col justify-between transform transition-transform duration-300 hover:scale-105">
//                             <div>
//                                 <h2 className="text-2xl font-bold mb-2">{job.title}</h2>
//                                 <p className="mb-2">{job.description}</p>
//                                 <p className="text-gray-600">{job.location}</p>
//                             </div>
//                             <button className="mt-4 px-4 py-2 bg-csyellow text-white rounded-lg hover:bg-csgreendark transition-colors duration-300">
//                                 Learn More
//                             </button>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             <div className="footer-div mt-8">
//                 <Footer />
//             </div>
//         </div>
//     );
// };

// export default Careers;


import React, { useState } from 'react';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import jobOpenings from '../../Data/jobOpenings.json';
import FadeInSection from "../../Components/FadeInSection.jsx";
import SearchBar from "../Verification/SearchBar.jsx";
import Banner from "../../Components/Banner";
import CareersBody from './CareersBody.jsx';

const Careers = () => {
    const [filter, setFilter] = useState('');
    
    const filteredJobs = jobOpenings.filter(job => 
        job.title.toLowerCase().includes(filter.toLowerCase()) ||
        job.description.toLowerCase().includes(filter.toLowerCase()) ||
        job.location.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            
            <main className="flex-grow font-ubuntu bg-topo-bg careers">
                <Banner
                    imageUrl="./banner1.svg"
                    title="Careers"
                    subtitle="Join us in our mission to make the roads safer for everyone."
                />
                
                <div className="max-w-6xl mx-auto px-4 py-8">
                    <FadeInSection>
                        <div className="mb-8">
                            <h2 className="text-3xl font-bold text-csyellow mb-4">Open Positions</h2>
                            <p className="text-lg text-gray-600">
                                We're looking for passionate individuals to join our team. Browse our current openings below.
                            </p>
                        </div>
                    </FadeInSection>
                    
                    {/* <div className="mb-8">
                        <SearchBar />
                    </div> */}

                    <CareersBody/>
                    
                    {/* {filteredJobs.length === 0 ? (
                        <div className="text-center py-12">
                            <p className="text-xl text-gray-600">No matching positions found. Please try a different search.</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {filteredJobs.map((job) => (
                                <FadeInSection key={job.id}>
                                    <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 h-full flex flex-col transition-all duration-300 hover:shadow-xl hover:border-csyellow">
                                        <div>
                                            <div className="h-2"></div>
                                        </div>
                                        <div className="p-6 flex-grow">
                                            <div className="flex justify-between items-start mb-4">
                                                <h3 className="text-2xl font-bold text-csyellow">{job.title}</h3>
                                                <span className="inline-block px-3 py-1 text-sm font-medium bg-gray-100 text-gray-800 rounded-full">
                                                    {job.department || 'Full-time'}
                                                </span>
                                            </div>
                                            <p className="text-gray-600 mb-4">{job.description}</p>
                                            <div className="flex items-center text-gray-500 mb-6">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                <span>{job.location}</span>
                                            </div>
                                        </div>
                                        <div className="px-6 pb-6">
                                            <button className="w-full px-4 py-3 bg-csyellow text-white rounded-lg hover:bg-gray-400 transition-colors duration-300 font-medium focus:outline-none focus:ring-2 focus:ring-csyellow focus:ring-opacity-50">
                                                Learn More
                                            </button>
                                        </div>
                                    </div>
                                </FadeInSection>
                            ))}
                        </div>
                    )} */}
                </div>

                <section className="bg-gray-50 py-16">
                    <div className="max-w-4xl mx-auto px-4 text-center">
                        <FadeInSection>
                            <h2 className="text-3xl font-bold text-csyellow mb-6">Why Join Our Team?</h2>
                            <div className="grid md:grid-cols-3 gap-8 mt-8">
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="text-csyellow text-4xl mb-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-bold mb-2">Meaningful Impact</h3>
                                    <p className="text-gray-600">Help make roads safer and save lives through innovative technology.</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="text-csyellow text-4xl mb-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-bold mb-2">Growth Opportunities</h3>
                                    <p className="text-gray-600">Develop your skills and advance your career in a supportive environment.</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="text-csyellow text-4xl mb-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-bold mb-2">Collaborative Culture</h3>
                                    <p className="text-gray-600">Work with talented professionals in an inclusive and innovative team.</p>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </section>
            </main>
            
            <Footer />
        </div>
    );
};

export default Careers;